import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { fetchRecipeByHandle } from '../redux/actions/recipeActions';
import { Recipe } from '../types/shopify';
import { ReduxState } from '../types/redux';
import LoadingSpinner from '../components/common/LoadingSpinner';
import RecipeTemplate from '../components/templates/RecipeTemplate';
import SimplifiedHeader from '../components/common/SimplifiedHeader';
import Footer from '../components/naviagtions/Footer';

interface RecipeDetailProps {
  fetchRecipeByHandle: (blogHandle: string, recipeHandle: string) => Promise<Recipe | null>;
  currentRecipe: Recipe | null;
  isLoading: boolean;
  error: string | null;
}

const RecipeDetail: React.FC<RecipeDetailProps> = ({
  fetchRecipeByHandle,
  currentRecipe,
  isLoading,
  error
}) => {
  const { handle } = useParams<{ handle: string }>();
  
  useEffect(() => {
    if (handle) {
      // Fetch the recipe when component mounts or handle changes
      fetchRecipeByHandle('recipes', handle);
    }
  }, [fetchRecipeByHandle, handle]);
  
  if (isLoading) {
    return (
      <div className="container u-flex u-justify-center u-p--32">
        <LoadingSpinner />
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="container u-p--32">
        <div className="u-background--red u-color-white u-p--16 u-br--small">
          <p className="u-main-font--medium">{error}</p>
        </div>
        <div className="u-pt--16">
          <Link to="/browse/recipes" className="u-color-magenta u-main-font--medium">
            &larr; Back to Recipes
          </Link>
        </div>
      </div>
    );
  }
  
  if (!currentRecipe) {
    return (
      <div className="container u-p--32">
        <p className="u-main-font--large">Recipe not found</p>
        <div className="u-pt--16">
          <Link to="/browse/recipes" className="u-color-magenta u-main-font--medium">
            &larr; Back to Recipes
          </Link>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <SimplifiedHeader />
      <div className="u-background--lightgrey" style={{ flex: '1 0 auto' }}>
        <div className="container">
          {currentRecipe && (
            <RecipeTemplate
              title={currentRecipe.title}
              publishedAt={currentRecipe.publishedAt}
              author={currentRecipe.author}
              image={currentRecipe.image}
              excerpt={currentRecipe.excerpt}
              contentHtml={currentRecipe.contentHtml}
              tags={currentRecipe.tags}
              backLink="/browse/recipes"
              backLinkText="Back to Recipes"
            />
          )}
        </div>
      </div>
      <div style={{ flexShrink: 0 }}>
        <Footer />
      </div>
    </div>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  currentRecipe: state.recipes.currentRecipe,
  isLoading: state.recipes.isLoading,
  error: state.recipes.error
});

const mapDispatchToProps = {
  fetchRecipeByHandle
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipeDetail);
